export default __webpack_public_path__ + "static/media/mozart9.e11ce225.png";